import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { deleteRpc as deleteRpcDeprecated, fetchRpc as fetchRpcDeprecated, registerRpc as registerRpcDeprecated } from '../__generated__/chirp/com/hubspot/vendor/mcp/registry/rpc/UserMcpRegistrationRpc';
import { listConnectionsRpc, registerRpc, deleteRpc } from '../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpConnectionRegistryRpc';
import { getAvailableServersRpc } from '../__generated__/chirp/com/hubspot/vendor/mcp/registry/rpc/AvailableMcpServerRpc';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @temporary We are starting to use shared MCP connection registration API with DPG.
 * @expiration 2026-01-01
 * @responsibleTeam hs-si-datasync-fe
 * @deprecated Use fetchConnections instead
 */
export const fetchMCPRegistrations = authenticatorId => {
  return chirpClient.call(fetchRpcDeprecated, {
    request: {
      authenticatorId
    }
  });
};

/**
 * @temporary We are starting to use shared MCP connection registration API with DPG.
 * @expiration 2026-01-01
 * @responsibleTeam hs-si-datasync-fe
 * @deprecated Use deleteConnection instead
 */
export const deleteMCPRegistration = authenticatorId => {
  return chirpClient.call(deleteRpcDeprecated, {
    request: {
      authenticatorId
    }
  });
};

/**
 * @temporary We are starting to use shared MCP connection registration API with DPG.
 * @expiration 2026-01-01
 * @responsibleTeam hs-si-datasync-fe
 * @deprecated Use registerConnection instead
 */
export const registerMCPRegistration = (authenticatorId, secretId) => {
  return chirpClient.call(registerRpcDeprecated, {
    request: {
      authenticatorId,
      secretId
    }
  });
};

/**
 * @temporary We are starting to use shared MCP connection registration API with DPG.
 * @expiration 2026-01-01
 * @responsibleTeam hs-si-datasync-fe
 * @deprecated
 */
export const fetchAvailableMCPServers = () => {
  return chirpClient.call(getAvailableServersRpc, {
    request: {}
  });
};
export const registerConnection = (mcpServerId, secretId) => {
  return chirpClient.call(registerRpc, {
    request: {
      mcpServerId,
      secretId
    }
  });
};
export const fetchConnections = () => {
  return chirpClient.call(listConnectionsRpc, {
    request: {}
  });
};
export const deleteConnection = connectionId => {
  return chirpClient.call(deleteRpc, {
    request: {
      id: connectionId
    }
  });
};